import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Main from "./component/utils/Main";
import Home from "./component/utils/Home"
import PageNotFound from "./component/utils/pageNotFound"
import Shop from './component/shope/Shop'
import EachShop from './component/shope/EachShop'
import Cart from './component/utils/Cart'
import Profile from './component/utils/Profile'
import SignIn from './component/sign/signIn'
import SignUp from './component/sign/signUp'
import axios from "axios";
import TopBarProgress from "react-topbar-progress-indicator"
import SavedPost from "./component/utils/SavedPost";
import UserSettings from "./component/account/UserSettings";
import EachShopPost from "./component/shope/EachShopPost";
import Subscribers from "./component/shope/Subscribers";
import ShopSettings from "./component/shope/ShopSettings";
import Create from "./component/shope/Create";
import ShopAdmins from "./component/shope/ShopAdmins"
import ShopCategories from "./component/shope/category/ShopCategories";
import Categories from "./component/shope/category/Categories";
import Material from "./component/shope/material/materials";
import EachCategory from "./component/shope/category/EachCategory";
import EachMaterials from "./component/shope/material/eachMaterial";

import Chat from "./component/utils/chat"
import MainChat from "./component/utils/mainChat"
import Notification from "./component/utils/Notification"
import Each_chat from "./component/utils-supporter/Each_chat"

//import  './component/config/messaging_init_in_sw';
import Test from "./component/test"

 function App() {
  
  let [userData,setUserData]=useState(JSON.parse(localStorage.getItem("895u64jxdnvjkf-ghdfjg65745cnx-gncmghnfgs5-zg-aethb Bth-5gsdfggdbz"))||{
    logged:false,
    data:{},
})

  let [isUserRegistered,checkIfUserRegistered]=useState(false)
  let [equilizer,setEquilizer]=useState(0)

//save userdata to local storage
  useEffect(()=>{ 
      localStorage.setItem("895u64jxdnvjkf-ghdfjg65745cnx-gncmghnfgs5-zg-aethb Bth-5gsdfggdbz",JSON.stringify(userData))
      if(userData.data?.registeredUserId){
        checkIfUserRegistered(true)
      }
      else checkIfUserRegistered(false)

  },[userData])

  //get user data whenever equilizer is updated from any where
 // const location = useLocation()
  useEffect(()=>{

    if(userData?.data?._id){
        axios.get(`${process.env.REACT_APP_URL}/api/user/get_user`, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })
        .then(res=>{
          setUserData(res.data)
        })
        .catch(error=>{
           console.log(error);
        })
    }
  },[equilizer])

  let [shopOptimizer,handleShopeOptimizer]=useState(0)
  let [currentShope,handleCurrentShope]=useState(JSON.parse(localStorage.getItem("895u64jxdnvjkf-ghdfjg65-duindjdb-bdaab-a35553-mlfdc"))||"")
  let [userShope,handleUserShope]=useState(JSON.parse(localStorage.getItem("895u64jxdnvjkf-jfndfjk-95y357348jnvdf-40369"))||[])

   // get all users shope whenever userdata and shopOptimizer is updated and 
  useEffect(()=>{
    if(userData?.data?._id){
      axios.get(`${process.env.REACT_APP_URL}/api/shope/getUserShopes`, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })
      .then(res=>{
        handleUserShope(res.data)
      })
      .catch(error=>{
         console.log(error);
      })
    }
  },[shopOptimizer,userData])
  
  //save user shope
  useEffect(()=>{
    localStorage.setItem("895u64jxdnvjkf-jfndfjk-95y357348jnvdf-40369",JSON.stringify(userShope))
  },[userShope])

  //save active shope 
  useEffect(()=>{
    localStorage.setItem("895u64jxdnvjkf-ghdfjg65-duindjdb-bdaab-a35553-mlfdc",JSON.stringify(currentShope))
  },[currentShope])

  //make the active shope the first index if there is no saved active shope on localstorage
  useEffect(()=>{
    if(userShope.length>=1&&!currentShope){
      handleCurrentShope(userShope[0]?._id||"")
    }
  },[userShope,shopOptimizer])

  useEffect(()=>{
    if(new Date(userData?.tokenExpirationDate).getTime()<=new Date().getTime()){
        setUserData({logged:false,data:{}})
      }
  },[userData])

  //console.log(userShope,currentShope)

  let propsData={
    shopOptimizer:shopOptimizer,
    handleShopeOptimizer:handleShopeOptimizer,
    currentShope:currentShope,
    handleCurrentShope:handleCurrentShope,
    userShope:userShope,
    handleUserShope:handleUserShope,
    equilizer:equilizer,
    setEquilizer:setEquilizer,
    userData:userData,
    setUserData:setUserData,
  }

  let [online,handleOnline]=useState({chat:"",istyping:false,unread:false})
  let [notification,setNotification]=useState(new Set())
  let [controlUnread,handleControlUnread]=useState(0)
  let [flagUnread,handleFlagUnread]=useState([])
  let unread={
   controlUnread:controlUnread,
   handleControlUnread:handleControlUnread,
   flagUnread,
   handleFlagUnread
  }
  
  let [latestMessage,handleLatestMessage]=useState([])
 
  return (
  <BrowserRouter>
   <section className='main'>
       <link rel="apple-touch-icon" href="alif-dev's102023_200748.png" />
          <ScrollToTop /> 
          <CustomRoutes>
              <Route path='/' element={<Main unread={unread} propsData={propsData}/>}>
                  <Route path='' element={<Home propsData={propsData}/>}/>
                  <Route path='categories' element={<Categories propsData={propsData}/>}/>
                  <Route path='categories/:id' element={<EachCategory propsData={propsData}/>}/>
                  <Route path='materials' element={<Material propsData={propsData}/>}/>
                  <Route path='test' element={<Test propsData={propsData}/>}/>
                  <Route path='materials/:id' element={<EachMaterials propsData={propsData}/>}/>
                 {userData?.data?._id&&
                   <>
                      <Route path="/cart" element={<Cart propsData={propsData}/>} />
                      <Route path="/profile" element={<Profile propsData={propsData}/>} >
                        <Route  path='' element={<UserSettings  propsData={propsData} />} />
                          <Route path='cart' element={<Cart   propsData={propsData}/>} />
                          <Route path='savedPost' element={<SavedPost  propsData={propsData} />} />
                          <Route path='shop'>
                            <Route  path=""  element={<Shop  propsData={propsData}/>} >
                                <Route  path="create" element={<Create  propsData={propsData}/>} />
                            </Route>
                          </Route>
                      </Route> 
                        <Route path="/shop/:id" element={<EachShop  propsData={propsData}/>}>
                              <Route index element={<EachShopPost  propsData={propsData} />} />
                              <Route path="subscriber" element={<Subscribers  propsData={propsData} />} />
                              <Route path="setting" element={<ShopSettings   propsData={propsData}/>} />
                              <Route path="admins" element={<ShopAdmins   propsData={propsData}/>} />
                              <Route path="categories" element={<ShopCategories   propsData={propsData}/>} />
                        </Route>

                        <Route path='/chat' element={<MainChat  online={online} handleOnline={handleOnline} notification={notification} setNotification={setNotification} propsData={propsData} ActiveShope={propsData.currentShope} HandleActiveShope={propsData.handleCurrentShope} userData={propsData.userData} setUserData={propsData.setUserData}/>}>
                            <Route path='' element={<Chat handleLatestMessage={handleLatestMessage} latestMessage={latestMessage}  unread={unread} online={online} handleOnline={handleOnline} notification={notification} setNotification={setNotification} propsData={propsData}  optimizer={propsData.equilizer} handle_optimizer={propsData.setEquilizer} ActiveShope={propsData.currentShope} HandleActiveShope={propsData.handleCurrentShope} userData={propsData.userData} setUserData={propsData.setUserData}/>}>
                                <Route path=':each' element={<Each_chat handleLatestMessage={handleLatestMessage} latestMessage={latestMessage}  unread={unread} online={online} handleOnline={handleOnline} notification={notification} setNotification={setNotification} propsData={propsData}  optimizer={propsData.equilizer} handle_optimizer={propsData.setEquilizer} ActiveShope={propsData.currentShope} HandleActiveShope={propsData.handleCurrentShope} userData={propsData.userData} setUserData={propsData.setUserData}/>}/>
                            </Route>  
                            <Route path='*' element={<PageNotFound userData={userData} setUserData={setUserData}/>}/>
                        </Route>

                        <Route path="/notifications" element={<Notification propsData={propsData}/>} />

                      
                   </>
                  }
                     
                    {/* <Route path="/shop">
                      <Route index  element={<Shop propsData={propsData} />} />
                      <Route path=":id" element={<EachShop propsData={propsData}/>} />
                    </Route> */}
                    <Route path='/SignIn' element={<SignIn setUserData={propsData.setUserData}/>}/>
                    <Route path='/SignUp' element={<SignUp propsData={propsData}/>}/> 
                  <Route path='*' element={<PageNotFound propsData={propsData}/>}/>
              </Route>   
          </CustomRoutes>
    </section>
   
</BrowserRouter>
  );
}

TopBarProgress.config({
  barColors: {
    "0": "#fff",
    "1.0": "#fff"
  },
  shadowBlur: 5
});

const CustomRoutes = ({ children }) => {

  const [progress, setProgress] = useState(false)
  const [prevLoc, setPrevLoc] = useState("")
  const location = useLocation()

    useEffect(() => {
      setPrevLoc(location.pathname)
      setProgress(true)
      if(location.pathname===prevLoc){
          setPrevLoc('')
          //thanks to ankit sahu
      }
  }, [location])

  useEffect(() => {
      setProgress(false)
  }, [prevLoc])


  return (
    <>
         {progress && <TopBarProgress />}
        <Routes>
            { children }
        </Routes>

    </>
  )
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return null;
}


export default App;